// extracted by mini-css-extract-plugin
module.exports = {"hidden":"header_hidden__PH7cy","textEmphasis":"header_textEmphasis__tpcM2","headerArea":"header_headerArea__m6Jc1","arrowBtn":"header_arrowBtn__KYpmR","date":"header_date__NX3hb"};